import React, { FC } from 'react';
import { Box } from '@mui/material';
import BreadcrumbComponent from '../BreadcrumbComponent/BreadcrumbComponent';
import { AlertType } from '../../types/AlertType';
import AlertComponent from '../common/AlertComponent/AlertComponent';
import boddVariables from '../../variables.module.scss';

interface NavigationPageProps {
    alertType?: AlertType;
    children: React.ReactNode;
}

const NavigationPage: FC<NavigationPageProps> = (props) => {
    const { alertType, children } = props;
    return (
        <Box
            data-testid="NavigationPage"
            sx={{
                width: '100%',
                boxSizing: 'border-box',
                px: boddVariables.sp3,
                py: boddVariables.sp3,
            }}
        >
            {alertType && (
                <AlertComponent Type={alertType!} />
            )}
            <BreadcrumbComponent />
            <Box sx={{ height: '16px' }} />
            {children}
        </Box>
    );
};

NavigationPage.defaultProps = {
    alertType: undefined,
};

export default NavigationPage;
